import { FormAsyncSelectFieldProps } from '@mews/framework';
import { BillingSearchForReservationsForLinkingResult } from '@mews-commander/data-access';
import { ReservationList } from './ReservationList';
import { renderReservationList } from './renderReservationList';

interface ReservationSelectSimpleProps
    extends Omit<
        FormAsyncSelectFieldProps<BillingSearchForReservationsForLinkingResult>,
        'useDataQuery' | 'renderData'
    > {
    accountId: string;
}

export const ReservationAsyncSelectSimple = ({ accountId, ...props }: ReservationSelectSimpleProps) => {
    const renderData = (rs: BillingSearchForReservationsForLinkingResult) => renderReservationList(rs, accountId);
    const defaultOptions = renderData([]);

    return (
        <ReservationList
            {...props}
            showOnlyUnpaidReservations
            renderData={renderData}
            defaultOptions={defaultOptions}
        />
    );
};
